"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPercentage = void 0;
var getPercentage = function (_a) {
    var value = _a.value, max = _a.max;
    if (!max || max === 0) {
        return 0;
    }
    return Math.round((value / max) * 100);
};
exports.getPercentage = getPercentage;
//# sourceMappingURL=getPercentage.js.map